import { fontColor, FONTS, fontSize } from "../../../styles/fonts";
import React from "react";

export const SearchResultsHeadline: React.FC<React.PropsWithChildren> = props => {
  return (
    <h3 className="u-uppercase u-mt-0" css={[FONTS.SwarovskiFutura500, fontColor.black, fontSize.x2]}>
      {props.children}
    </h3>
  );
};
